import { Combobox, Option } from "@fluentui/react-components";
import { useItemQuery } from "../../../shared/hooks/useItemQuery";
import { readSites } from "../../sites/services/siteApi";

export default function SiteComboBox({ value, onOptionSelect, ...ComboboxProps }) {
  const { data: sites = [], isLoading } = useItemQuery(["sites"], readSites, true);

  // Find the name that corresponds to the selected ID
  const selectedSite = sites.find((loc) => loc.id === value);
  const selectedName = selectedSite?.name ?? "";

  const handleSelect = (_, data) => {
    if (!data) return;
    const selected = data.optionValue;
    const matched = sites.find((s) => s.name === selected);
    console.log(`New site ${matched.id}`);
    onOptionSelect?.(matched?.id ?? null); // pass back the ID
  };

  return (
    <Combobox
      value={selectedName}
      onOptionSelect={handleSelect}
      placeholder={isLoading ? "Loading sites..." : "Select a site"}
    >
      {sites.map((s) => (
        <Option key={s.id} value={s.name}>
          {s.name}
        </Option>
      ))}
    </Combobox>
  );
}
